module.exports = __webpack_public_path__ + "static/media/certificateIcon.305a5688.svg";